module.exports = __webpack_public_path__ + "img/peak-district.2.014d8e0.jpg";